import {useState} from "react";
import CourseList from "../components/CourseList";
import CourseForm from "../components/CourseForm";
import {Box, Modal} from "@mui/material";
import {useAlert} from "../context/AlertContext";
import AppModalBox from "../components/AppModalBox";

const CoursesPage = () => {
    const [open, setOpen] = useState(false);
    const {showAlert} = useAlert();
    const [refresh, setRefresh] = useState(false);
    const refreshCourses = () => {
        setRefresh((prev) => !prev);
    };

    const handleCourseAdded = () => {
        setOpen(false);
        refreshCourses();
        showAlert("Course added successfully!", "success");
    };

    const handleError = (error: string) => {
        showAlert(`Error: ${error}`, "error");
    };

    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <CourseList onAdd={() => setOpen(true)} refreshTrigger={refresh} refreshCourses={refreshCourses}/>
            <Modal open={open} onClose={() => setOpen(false)}>
                <AppModalBox>
                    <CourseForm
                        onClose={() => setOpen(false)}
                        onSuccess={handleCourseAdded}
                        onError={handleError}
                    />
                </AppModalBox>
            </Modal>
        </Box>
    );
};

export default CoursesPage;